<template>
	<el-drawer class="breath-operate-table" title="完成外呼" :visible.sync="dialog_visible" :wrapperClosable="false"
		size="800px" direction="rtl">
		<el-form :model="form" :rules="rules" ref="form" label-width="100px" style="padding: 0 20px;">
		  <el-form-item label="任务结果" prop="statusType">
			  <el-radio-group v-model="form.statusType" @change="radioChange">
				  <el-radio-button label="success">成功</el-radio-button>
				  <el-radio-button label="fail">失败</el-radio-button>
				</el-radio-group>
		  </el-form-item>
			<el-form-item label="任务状态" prop="taskStatus">
				<el-select v-model="form.taskStatus" placeholder="请选择任务状态" filterable :filter-method="getTaskStatus" clearable  style="width: 100%;"
					 @focus="getTaskStatus()" :loading="loading"  @change="onTaskStatusChange">
					<el-option v-for="item in task_option" :key="item.statusCode" :label="item.statusName"  :disabled="item.statusState != '1'"
						:value="item.statusCode">
					</el-option>
				</el-select>
			</el-form-item>
			<el-form-item label="拒绝原因" v-if="$store.getters.userInfo.brandIdentify == brandName && isShowdefault == '拒绝'" prop="subTaskStatus">
				<el-select v-model="form.subTaskStatus" placeholder="请选择拒绝原因" clearable  style="width: 100%;" @change="subTaskStatusChange">
					<el-option value="不需要主理联系，自行看车">不需要主理联系，自行看车</el-option>
					<el-option value="等地方门店开放">等地方门店开放</el-option>
					<el-option value="考虑其他品牌">考虑其他品牌</el-option>
					<el-option value="暂无购车计划">暂无购车计划</el-option>
					<el-option value="价格超预算">价格超预算</el-option>
					<el-option value="其他原因（见备注）">其他原因（见备注）</el-option>
					<el-option value="不需要，未告知原因">不需要，未告知原因</el-option>
					<el-option value="认为是骚扰电话">认为是骚扰电话</el-option>
					<el-option value="已购其他车辆">已购其他车辆</el-option>
					<el-option value="没有留资印象">没有留资印象</el-option>
					<el-option value="非本人">非本人</el-option>
				</el-select>
			</el-form-item>
			<el-form-item label="处理结果" v-if="$store.getters.userInfo.brandIdentify == brandName" prop="processResult">
				<el-select v-model="form.processResult" placeholder="请选择处理结果" clearable  style="width: 100%;" :disabled="form.taskStatus == '103'">
					<el-option v-for="(item,index) in result_options" :key="index" 
					:label="item.name" :value="item.code"></el-option>
				</el-select>
			</el-form-item>
			  <el-form-item label="任务备注">
			    <el-input type="textarea" v-model="form.finishTaskRemarks" placeholder="请输入任务备注"></el-input>
			  </el-form-item>
			  <!-- <el-form-item label="预约下次外呼" v-if="isShowdefault == '预约下次'">
				<el-switch v-model="form.is_finish" active-text="是" inactive-text="否"></el-switch>
			  </el-form-item> -->
			  <el-form-item prop="appionObTime" label="下次外呼时间" v-if="$store.getters.userInfo.brandIdentify == brandName && is_show_appoint">
				  <el-date-picker
						:picker-options="setDisabledDate"
				        v-model="form.appionObTime"
				        type="datetime"
						value-format="yyyy-MM-dd HH:mm:ss"
						:clearable="false"
				        placeholder="选择下次外呼时间">
				      </el-date-picker>
			  </el-form-item>
			  <el-form-item label="下次外呼时间" v-if="$store.getters.userInfo.brandIdentify != brandName">
				  <el-date-picker
						:picker-options="setDisabledDate"
				        v-model="form.appionObTime"
				        type="datetime"
						:clearable="false"
						value-format="yyyy-MM-dd HH:mm:ss"
				        placeholder="选择下次外呼时间">
				      </el-date-picker>
			  </el-form-item>
			  <el-form-item style="float: right;">
				  <el-button size="small" @click="dialog_visible = false">取 消</el-button>
				  <el-button type="primary" size="small" @click="onFinish" :loading="btn_loading">{{btn_loading ? '提交中' : '完成外呼'}}</el-button>
			  </el-form-item>
		</el-form>
	</el-drawer>
</template>

<script>
import {  formatDate } from 'utils/index';
	export default {
		props:['paperName','callout_id', 'obTimes', 'createTime', 'obCount'],
		computed: {
			setDisabledDate() {
				let that = this;
				return {
					disabledDate(time){
						let now = new Date();
						now.setHours(now.getHours());
						now.setMinutes(now.getMinutes());
						now.setSeconds(now.getSeconds());
						return time < now;
					}
				}
			}
		},
		watch: {
			is_show_appoint: {
				handler(val) {
					if(val && this.$store.getters.userInfo.brandIdentify == this.brandName) {
						let now = new Date();
						if((this.isToday(this.createTime) && this.obTimes >= 2) || now.getHours() >= 17) {
							now.setDate(now.getDate() + 1);
							now.setHours(10);
							now.setMinutes(0);
							now.setSeconds(0);
							this.form.appionObTime = formatDate(now, 'YYYY-MM-DD HH:mm:ss');
						} else {
							now.setHours(now.getHours() + 4);
							this.form.appionObTime = formatDate(now, 'YYYY-MM-DD HH:mm:ss');
						}
					} else {
						this.form.appionObTime = '';
					}
				}
			},
			'form.processResult': {
				handler(val) {
					this.is_show_appoint = (val == '5') ? true : false;
				}
			},
		},
		data() {
			return {
				tuid:'',
				dialog_visible: false,
				loading: false,
				btn_loading:false,
				task_option: [],
				form: {
					statusType: '',
					taskStatus: '',
					subTaskStatus:'',
					finishTaskRemarks:'',
					is_finish:false,
					appionObTime:'',
					processResult:'',
				},
				rules:{
					statusType:[{required:true,message:'请选择任务结果',trigger:'change'}],
					taskStatus:[{required:true,message:'请选择任务状态',trigger:'change'}],
					appionObTime:[{required:true,message:'请选择下次预约时间',trigger:'change'}],
					processResult:[{required:true,message:'请选择任务处理结果',trigger:'change'}],
					subTaskStatus:[{required:true,message:'请选择拒绝原因',trigger:'change'}],
				},
				row:'',
				brandName:process.env.VUE_APP_BRANDNAME,
				isShowdefault:'none',//是否展示拒绝
				action_val:{
					'1':'1',//0 更新 1 下发 2战败 3 无效
					'2':'1',
					'3':'2',
					'4':'3',
					'5':'0',
					'6':'0'
				},
				origin_result_options:[
					{name:'下发门店',code:'1'},
					{name:'下发孵化',code:'2'},
					{name:'战败',code:'3'},
					{name:'无效',code:'4'},
					{name:'继续外呼',code:'5'},
					{name:'已取消',code:'6'}
				],
				result_options:[],
				result_val:{
					'下发-门店':[[{name:'下发门店',code:'1'}],false],
					'下发-孵化中心':[[{name:'下发孵化',code:'2'}],false],
					'拒绝':[[{name:'下发孵化',code:'2'},{name:'战败',code:'3'}],false],
					'再联系':[[{name:'继续外呼',code:'5'}],true],
					'中途挂机':[[{name:'继续外呼',code:'5'}, {name:'战败',code:'3'}],true],
					'无人接听':[[{name:'继续外呼',code:'5'}, {name:'战败',code:'3'}],true],
					'忙音':[[{name:'继续外呼',code:'5'}, {name:'战败',code:'3'}],true],
					'停机':[[{name:'继续外呼',code:'5'}, {name:'战败',code:'3'}],true],
					'空号':[[{name:'无效',code:'4'}],false],
					'错号':[[{name:'无效',code:'4'}],false],
					'语音提醒（不在服务区/来电秘书）':[[{name:'继续外呼',code:'5'}, {name:'战败',code:'3'}],true],
					'虚拟运营商':[[{name:'无效',code:'4'}],false],
					'拒接':[[{name:'继续外呼',code:'5'}, {name:'战败',code:'3'}],true],
					'关机':[[{name:'继续外呼',code:'5'}, {name:'战败',code:'3'}],true],
				},
				is_show_appoint:false,
			}
		},
		methods: {
			isToday(str) {
				return new Date().getTime() - new Date(str).getTime() < 86400000;
			},
			subTaskStatusChange(val){
				switch(val){
					// case '不需要主理联系，自行看车':
					// case '等地方门店开放':
					// case '考虑其他品牌':
					// case '暂无购车计划':
					// case '价格超预算':
					// 	this.form.processResult = '2';
					// 	break;
					// case '其他原因（见备注）':
					// case '不需要，未告知原因':
					// case '认为是骚扰电话':
					// case '已购其他车辆':
					// case '没有留资印象':
					// case '非本人':
					// 	this.form.processResult = '3';
					// 	break;
					// default:
					// 	this.form.processResult = '';
					// 	break;
					case '等地方门店开放':
						this.form.processResult = '2';
						break;
					default:
						this.form.processResult = '3';
						break;
				}
			},
			onTaskStatusChange(val){
				let index = this.task_option.findIndex(el => el.statusCode == val);
				if(this.result_val[this.task_option[index]?.statusName]){
					if(['105', '106', '107', '108', '111', '113', '114'].includes(val)) {
						if(this.obCount > 2) {
							this.result_options = [this.result_val[this.task_option[index].statusName][0][1]];
						} else {
							this.result_options = [this.result_val[this.task_option[index].statusName][0][0]];
						}
					} else {
						this.result_options = this.result_val[this.task_option[index].statusName][0];
					}
					
					// this.is_show_appoint = this.result_val[this.task_option[index].statusName][1];
				}else {
					this.result_options = this.origin_result_options;
				}
				this.form.processResult = '';
				if(val == '103') {
					 this.isShowdefault = '拒绝';
					 return;
				}
				this.isShowdefault = 'none';
				this.form.subTaskStatus = '';
				
				
			},
			radioChange(){
				this.form.taskStatus = '';
				this.isShowdefault = 'none';
				this.form.subTaskStatus = '';
			},
			onFinish(){
				this.$refs.form.validate((valid) => {
					if(valid){
						console.log(this.form)
						if(this.$store.getters.userInfo.brandIdentify == this.brandName){
							if(!this.form.processResult){
								return this.$notify.error('请选择处理结果')
							}
							if(this.form.processResult == 1 && !this.row.c_mendianmingcheng){
								return this.$notify.error('请去原始数据中填写下发门店')
							}
							if(this.form.processResult == 2 && !this.row.c_fuhuazhongxinmingchen){
								return this.$notify.error('请去原始数据中填写孵化中心')
							}
							if(this.row.c_shipitianjiaweishen == '是' && !this.row.c_weixinshoujihao){
								return this.$notify.error('请去原始数据中完善微信手机号')
							}
						
						}
						this.btn_loading = true;
						let params = {
							brandIdentify:this.$store.getters.userInfo.brandIdentify,
							taskId:this.row.taskId,
							taskStatus:this.form.taskStatus,
							subTaskStatus:this.form.subTaskStatus,
							subjectId:this.row.subjectId,
							paperId:this.row.paperId,
							campaignId:this.row.campaignId,
							paperSaveId:this.row.paperSaveId,
							custId:this.row.custId,
							processResult:this.form.processResult
						}
						if(this.form.appionObTime){
							params.appoinObTime = this.form.appionObTime;
							params.appoinTaskRemarks = this.form.finishTaskRemarks
							this.$api.appointTaskBreathTaskInfos(params).then(res => {
								this.btn_loading = false;
								if(res.errcode != 0) return;
								this.$notify.success('预约成功');
								this.dialog_visible = false;
								this.$emit('getNextTask',this.row);
								if(this.$store.getters.userInfo.brandIdentify == this.brandName){
									this.toSendData();
								}
							}).catch(err => {
								this.btn_loading = false;
							})
						}else {
							params.finishTaskRemarks = this.form.finishTaskRemarks,
							this.$api.finishTaskBreathTaskInfos(params).then(res => {
								this.btn_loading = false;
								if(res.errcode != 0) return;
								this.$notify.success('完成外呼');
								this.dialog_visible = false;
								this.$emit('getNextTask',this.row);
								if(this.$store.getters.userInfo.brandIdentify == this.brandName){
									this.toSendData();
								}
							}).catch(err => {
								this.btn_loading = false;
							})
						}
						
					}
				})
			},
			
			onShow(data){
				this.dialog_visible = true;
				this.row = data;
				this.$nextTick(() => {
					Object.keys(this.form).map(item => {
						this.form[item] = '';
					})
				})
			},
			getTaskStatus(query) {
				this.loading = true;
				this.$api.getBreathTaskStatus({
					brandIdentify: this.$store.getters.userInfo.brandIdentify,
					statusType: this.form.statusType,
					statusState:'1',
					statusName:query || ''
				}).then(res => {
					this.loading = false;
					if (res.errcode != 0) return;
					this.task_option = res.data.filter(el => el.statusCode > 1);
					
				})
			},
			// 推送线索
			toSendData(){
				this.$api.finishBreathTaskToSendData({
					account:this.$store.getters.userInfo.account,
					action:this.action_val[this.form.processResult] || '',
					callType:1,
					custId:this.row.custId,
					incidentId:this.callout_id,
					leadId:this.row.c_xiansuoid || '',
					processResult:this.form.processResult,
					questionnairType:this.paperName,
					questionnairTypeCode:this.row.paperId,
					result:this.form.taskStatus,
					taskId:this.row.taskId,
					denialReason:this.form.subTaskStatus,
					nextCallTime:this.form.appionObTime,
					remark:this.form.finishTaskRemarks,
				}).then(res => {
					if(res.errcode != 0) return;
				})
			},
		},
	}
</script>

<style>
</style>
